export const NFT_CONTRACT_ADDRESS =
  "0x39bb3510039892071969E22DE2F41A4160cE7f4f";

export const TOTAL_SUPPLY = 2121;

export const FAKE_TOTAL = 2111;
